import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCashapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.4444 9c-.8888-.7778-2.0555-1.1667-3.2222-1.1667-1 0-1.9444.3334-1.9444 1.2223 0 .8333.8889 1.1666 1.9444 1.5555.1111.0556.2222.0556.3334.1111 2.1111.7222 3.8888 1.6111 3.8888 3.6667 0 2.2778-1.7777 3.7778-4.6111 4l-.2777 1.2222c-.0556.2222-.2223.3889-.5.3889H9.2778c-.1667 0-.2778-.0556-.389-.1667-.111-.1111-.111-.2777-.111-.3889l.2778-1.2777C8 17.8889 7 17.3333 6.1666 16.5556q-.1665-.1668-.1666-.3334c0-.1111.0556-.2778.1667-.3333l1-1c.1666-.1667.5-.1667.6666 0 .889.8889 2.1667 1.3333 3.3889 1.3333 1.2778 0 2.1667-.5555 2.1667-1.4444 0-.7778-.7222-1.0556-2.1111-1.5556-.1667-.0555-.2778-.1111-.4445-.1666-1.7777-.6112-3.4444-1.5556-3.4444-3.6112 0-2.4444 2-3.611 4.4444-3.7222L12.1111 4.5c0-.3889.2222-.5.4445-.5h1.7777c.1667 0 .2778.0556.3889.1667s.1111.2777.1111.3889l-.2777 1.3888c.8888.2778 1.7777.7778 2.5 1.389q.1666.1666.1666.3333c0 .111-.0555.2777-.1666.3333l-.9445.9444c-.1667.2223-.5.2223-.6667.0556"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCashapp
